// Barril de la biblioteca `dxc-*`.
// Catálogo y normativa: .claude/rules/dxc-components.rule.md

export * from './dxc.types';
export * from './panel/dxc-panel-anchor';
export * from './text/dxc-match';
export * from './text/dxc-file-format';

export * from './select/dxc-select.component';
export * from './multiselect/dxc-multiselect.component';
export * from './autocomplete/dxc-autocomplete.component';
export * from './table/dxc-table.component';
export * from './page-header/dxc-page-header.component';
export * from './section-head/dxc-section-head.component';
export * from './status-badge/dxc-status-badge.component';
export * from './alert/dxc-alert.component';
export * from './tabs/dxc-tabs.component';
export * from './chart/dxc-bar-chart.component';
export * from './chart/dxc-donut.component';
export * from './state-icon/dxc-state-icon.component';
export * from './icon/dxc-icon.component';
export * from './count-up/dxc-count-up.directive';
export * from './scroll-hint/dxc-scroll-hint.directive';
export * from './media/dxc-media';
export * from './time-field/dxc-time-field.component';
export * from './number-field/dxc-number-field.component';
export * from './rating/dxc-rating.component';
export * from './otp-field/dxc-otp-field.component';
export * from './upload/dxc-upload.component';
export * from './attachments/dxc-attachments.component';
export * from './brand/dxc-brand.component';
export * from './brand/dxc-splash.component';
export * from './scene/dxc-scene.component';
export * from './dialog/dxc-dialog.service';
export * from './dialog/dxc-dialog-host.component';
export * from './tour/dxc-tour.service';
export * from './tour/dxc-tour-host.component';
